<div class="modal-header justify-content-end pb-0 border-0">
    <button type="button" class="btn btn-icon btn-close btn-transparent" aria-label="Close" (click)="decline()">
        <sb-inline-svg
            class="icon icon-close"
            aria-label="My icon"
            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
        </sb-inline-svg>
    </button>
</div>

@if (isLoading) {
    <sb-loader></sb-loader>
} @else {
    <div class="modal-body pb-0" tabindex="-1" appFocus [appAutoFocus]="true">
        @for (transaction of contactTransactions; track transaction; let index = $index) {
            <section id="{{ 'contactMessagesTable' + index }}" class="settings-wrapper pt-0 pe-0 ps-0">
                <div class="header" (click)="toggleTable('contactMessagesTable' + index)">
                    <div class="d-flex align-items-center">
                        <span class="input-group-addon">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                        <p class="m-0 ps-3">
                            {{ transaction.createdDate | date: 'dd.MM.yyyy HH:mm' }} - {{ transaction.storeName }}
                        </p>
                    </div>
                    <div class="text-end">
                        <p class="m-0">
                            {{ 'Total:' | translate }}
                            {{ (transaction.localNetPriceSum | number: '.2') + ' (' + transaction.localCurrency + ')' }}
                        </p>
                        <p class="m-0">
                            {{ transaction.numberOfItems }}
                            {{ 'line items' | translate }}
                        </p>
                    </div>
                </div>
                <div class="body">
                    <div class="id">
                        {{ 'ID:' | translate }}
                        {{ transaction.transactionNumber }}
                    </div>
                    <div class="table-scroll">
                        <table class="sb-table mb-3">
                            <thead>
                                <tr>
                                    <th>{{ 'Article number' | translate }}</th>
                                    <th>{{ 'Article name' | translate }}</th>
                                    <th>{{ 'Article group' | translate }}</th>
                                    <th>{{ 'Product group kat4' | translate }}</th>
                                    <th>{{ 'Ordertype' | translate }}</th>
                                    <th>{{ 'Ordertype value' | translate }}</th>
                                    <th>{{ 'Quantity' | translate }}</th>
                                    <th>{{ 'Unit price' | translate }}</th>
                                </tr>
                            </thead>

                            <tbody>
                                @for (item of transaction.lineItems; track item) {
                                    <tr>
                                        <td>{{ item.articleNumber }}</td>
                                        <td>{{ item.articleName }}</td>
                                        <td>{{ item.articleGroup }}</td>
                                        <td>{{ item.produktgruppeKat4 }}</td>
                                        <td>{{ item.orderType }}</td>
                                        <td>{{ item.orderTypeValue }}</td>
                                        <td class="text-center">{{ item.quantity }}</td>
                                        <td class="text-end">{{ item.localPrice }}</td>
                                    </tr>
                                } @empty {
                                    <tr>
                                        <td class="no-data" colspan="100">
                                            {{ 'No data available in table' | translate }}
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div class="total">
                        <p>{{ 'Total' | translate }}</p>
                        <p>
                            {{ (transaction.localNetPriceSum | number: '.2') + ' (' + transaction.localCurrency + ')' }}
                        </p>
                    </div>
                </div>
            </section>
        }

        <sb-paging
            [activePage]="activePage"
            [itemCount]="totalItems"
            [pageSize]="pageSize"
            (pageChange)="activePage = $event; getContactTransactions(activePage)">
        </sb-paging>
    </div>
}
